module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_animal_structure_and_function_3-353ae8a7c6e8c471406875295bd816a4.jpg";